import React, { Component } from 'react';
import * as util from './util';
import './category-selector-rewrite.css';

//TODOS: category search, new category suggestion, help overlay
//       update surrounding form, replace old selector in all product types
//       check requirements again, consider leaves only,
//       show state of category selection (duplicates, finished y/n)

export class CategorySelectorList extends Component {
  constructor(props) {
    super(props);
    this.categoryInfo = {};
    this.addBox = this.addBox.bind(this);
    this.deleteBox = this.deleteBox.bind(this);
    this.updateCategory = this.updateCategory.bind(this);
    var initialCategories = [];
    this.state = {divIDs: [],
                  categories: initialCategories,
                  value: null,
                  finallySelected: null,
                  categoryLimit: (this.props.categoryLimit !== undefined ? this.props.categoryLimit : 6)
    };
  }

  componentWillReceiveProps(nextProps, nextState) {
    if (nextProps.value !== this.state.value) {
      var categories = (typeof nextProps.value ) === 'string' ? nextProps.value.split(',') : nextProps.value;
      categories = categories.map(item => parseInt(item,10)).filter(parsed => ! isNaN(parsed));
      if(categories.length === 0) {
        categories = new Array(0);
        categories.push(2);
      }
      var newIDs = new Array(0);
      for(var i=0; i<categories.length;i++) {
        newIDs.push(Math.round(Math.random()*1000000));
      }
      var newCategories = {};
      newIDs.map( (elt,i) => newCategories[elt]=categories[i] );
      this.setState({divIDs: newIDs,
                     categories: newCategories,
                     value: nextProps.value
      }, () => newIDs.map( id => this.updateCategory( newCategories[id], id )));
    }
  }

  updateCategory(id, divID) {
    var categories = this.state.categories;
    categories[divID]=id;
    if(this.categoryInfo[id] !== undefined) {
      this.setState({categories: categories},
                    () => this.setState({finallySelected: serializeCategories(this,this.state.categoryLimit,this.categoryInfo)},
                                        () => this.props.update(this.props.slot, this.state.finallySelected)));
    } else {
      var self = this;
      getCategoryInfo(id).then( function(json) {
        self.categoryInfo[id] = json;
        self.setState({categories: categories},
                      () => self.setState({finallySelected: serializeCategories(self,self.state.categoryLimit,self.categoryInfo)},
                                          () => self.props.update(self.props.slot, self.state.finallySelected)))
      })
    }
  }

  deleteBox(divID) {
    var array = this.state.divIDs;
    array = array.filter(id => id!==divID);
    var categories = this.state.categories;
    delete categories[divID];
    this.setState({divIDs: array,
                   categories: categories},
                  () => this.setState({finallySelected: serializeCategories(this,this.state.categoryLimit,this.categoryInfo)},
                                      () => this.props.update(this.props.slot, this.state.finallySelected)));
  }

  addBox() {
    var array = this.state.divIDs;
    var newID = Math.round(Math.random()*1000000);
    array.push(newID);
    var categories = this.state.categories;
    categories[newID] = 2;
    this.setState({divIDs: array,
                   categories: categories
    }, () => this.updateCategory(2, newID));
  }

  boxes() {
    var array = this.state.divIDs;
    var count = array.length;
    const max = this.state.categoryLimit;
    var self = this;
    array = array.map( function(divID,i) {
      var categoryID = self.state.categories[divID];
      if(self.categoryInfo[categoryID] !== undefined && self.categoryInfo[categoryID] !== null) {
        return <CategorySelectorBox
                   addButton={(i===count-1 && count<max) ? true : false}
                   deleteButton={count>1 ? true : false}
                   id={'CategorySelectorBox#'+divID}
                   divID={divID}
                   key={divID}
                   addBox={self.addBox}
                   deleteBox={self.deleteBox}
                   selectedCategory={self.state.categories[categoryID]}
                   updateCategory={self.updateCategory}
                   selectedCategoryName = {self.categoryInfo[categoryID].name}
                   selectedCategoryHasChildren = {self.categoryInfo[categoryID].hasChildren}
                   selectedCategoryChildren = {self.categoryInfo[categoryID].children}
                   selectedCategoryPath = {self.categoryInfo[categoryID].path}
                   selectedCategoryParent = {self.categoryInfo[categoryID].parent} />
      } else {
        return null;
      }}
    )
    return array;
  }

  overview() {
    if(this.state.finallySelected !== undefined && this.state.finallySelected !== null) {
      var n = this.state.finallySelected.split(',').filter( item => item !== '').length;
      if(n>0) {
        return <div className="CategorySelectorListOverview" style={{color: 'darkgreen'}}
               >{n + (n===1 ? ` Kategorie wurde ausgewählt. Noch ${this.state.categoryLimit-n} verfügbar.`
                    : ` Kategorien wurden ausgewählt. Noch ${this.state.categoryLimit-n} verfügbar.`)}</div>;
      }
      return <div className="CategorySelectorListOverview" style={{color: 'red'}}>Bisher wurde noch keine Kategorie ausgewählt.</div>
    }
  }

  render() {
    return(
      <div className="CategorySelectorList" id={Math.round(Math.random()*1000000)} >
        {this.overview()}
        {this.boxes()}
      </div>
    )
  }
}

class CategorySelectorBox extends Component {
  constructor(props) {
    super(props);
    this.search = this.search.bind(this);
    this.renderSearchResults = this.renderSearchResults.bind(this);
    this.state={selectedCategoryName: this.props.selectedCategoryName,
                selectedCategoryHasChildren: this.props.selectedCategoryHasChildren,
                selectedCategoryChildren: this.props.selectedCategoryChildren,
                selectedCategoryPath: this.props.selectedCategoryPath,
                selectedCategoryParent: this.props.selectedCategoryParent,
                childrenVisible: false,
                pathVisible: true,
                requestVisible: false,
                requestName: '',
                id: Math.round(Math.random()*1000000),
                searchString: '',
                searchResults: null
    };
  }

  componentWillReceiveProps(nextProps, nextState) {
    this.setState({selectedCategoryName: nextProps.selectedCategoryName,
                   selectedCategoryHasChildren: nextProps.selectedCategoryHasChildren,
                   selectedCategoryChildren: nextProps.selectedCategoryChildren,
                   selectedCategoryPath: nextProps.selectedCategoryPath,
                   selectedCategoryParent: nextProps.selectedCategoryParent,
                   searchString: '',
                   searchResults: null
    });
  }

  nodeStyle(i,length) {
    if(length===i+1) {
      return {color: 'black', fontWeight:'normal'};
    }
    return null;
  }

  renderPath() {
    var pathLength = this.state.selectedCategoryPath.length;
    var self = this;
    return (
      <span style={{color: '#1F6A81'}}>
        {this.state.selectedCategoryPath.map( function(obj,i) {
           return (
             <span>
               <span className="CategorySelectorPathSelection"
                     style={self.nodeStyle(i, pathLength)}
                     title={"Durch Klick springen Sie an diese Stelle des Kategorienbaumes. ("+obj.name+")"}
                     onClick={ event => self.props.updateCategory(obj.id,self.props.divID,self)} >{obj.name}</span>
               <span style={{color:'#1F6A81'}}>{i<pathLength-1 ? ' ▶ ' : null} </span>
             </span>);
         })}
      </span>
    );
  }

  search(searchString) {
    var headers = util.defaultHeaders();
    headers.append("Accept", "application/json");
    var url = `/api/category-search?search=${searchString}&startid=2`;
    var promise = fetch(url, {method: 'GET',
                              mode: 'cors',
                              headers: headers
    })
      .then(response => response.json())
      .catch(function(exception) {
        console.error(`Could not retreive category tree search results!`, exception);
      });
    return promise;
  }

  renderSearchResults() {
    return (
      <div className="CategorySelectorSearchResults">
        <ul>
          {this.state.searchResults !== null && this.state.searchResults.length > 0 && this.state.searchResults.map(
             (json) => <li onClick={ event => this.props.updateCategory(json.id,this.props.divID,this) }>{json.text}</li> )}
          {this.state.searchResults !== null && this.state.searchResults.length === 0 &&
           <span style={{color: 'red'}}>Keine Treffer.</span>}
        </ul>
      </div>
    )
  }

  render() {
    let self = this;
    return(
      <div className={this.state.selectedCategoryHasChildren === true ?
                      "CategorySelectorBox CategorySelectionUnfinished" :
                      "CategorySelectorBox CategorySelectionFinished"}
           key={this.props.id}
           id={this.state.id} >
        {this.state.selectedCategoryHasChildren === true ? <div style={{marginBottom: '15px', color: 'black'}}>Bitte wählen Sie eine Kategorie aus.</div> : null}
        {this.state.pathVisible === true && <span className="CategorySelectorPath">{this.renderPath()}</span>}
        {this.state.selectedCategoryParent !== 1 &&
         this.state.selectedCategoryHasChildren !== true &&
         <span title="Diese Kategorie bearbeiten."
               style={{cursor: "pointer", color: '#1F6A81'}}
               onClick={ event => self.props.updateCategory(this.state.selectedCategoryParent,self.props.divID,self)}> ✎ </span>
        }
         {this.props.deleteButton === true &&
          <span className="CategorySelectorBoxDelete"
                title="Diese Kategorie löschen!"
                onClick={(event) => this.props.deleteBox(this.props.divID)} >✗</span>
         }
          {this.props.deleteButton === false &&
           <span className="CategorySelectorBoxDelete"
                 title="Diese Kategorie löschen!"
                 onClick={(event) => this.props.updateCategory(2,self.props.divID,self)} >✗</span>
          }
           {this.props.addButton &&
            <div className="CategorySelectorBoxAdd"
                 title="Eine weitere Kategorie zur Auswahl hinzufügen!"
                 onClick={(event) => this.props.addBox()} >+ Eine weitere Kategorie auswählen.</div>
           }
            {this.state.childrenVisible === true && this.state.selectedCategoryHasChildren === true &&
             <div className="CategorySelectorChildrenVisibility" onClick={event => this.setState({childrenVisible: false})}>[Unterkategorien verbergen]</div>
            }
             {this.state.childrenVisible === false && this.state.selectedCategoryHasChildren === true &&
              <div className="CategorySelectorChildrenVisibility" onClick={event => this.setState({childrenVisible: true})}>[Unterkategorien anzeigen]</div>
             }
              {this.state.selectedCategoryHasChildren === true &&
               this.state.childrenVisible === true &&
               <div className="CategorySelectorChildren">
                 {this.state.selectedCategoryParent !== 1 &&
                  <div className="CategorySelectorBack"
                       title="Durch Klick kehren Sie einen Schritt zurück in Ihrer Auswahl."
                       onClick={ event =>
                         self.props.updateCategory(this.state.selectedCategoryParent,self.props.divID,self)}>←</div>
                 }
                  <ul>
                    {this.state.selectedCategoryChildren.map( function(child, i) {
                       return <li key={i} onClick={ event =>
                         self.props.updateCategory(child.id,self.props.divID,self)}
                                  className={child.hasChildren === true ?
                                             "CategorySelectionInnerNode" :
                                             "CategorySelectionFinalNode"} >
                    {child.name}
                    {child.hasChildren === true && <span style={{fontWeight: 'normal', color: '#1F6A81'}}
                                                         title="Weitere Kategorien folgen."> ▶ ...</span>}
                       </li>;
                     })
                    }
                       <li className="CategorySuggestion">
                         <input type="text" placeholder="Ihr Kategorievorschlag"
                                onChange={ event => this.setState({requestName: event.target.value}) } />
                         <span> </span>
                         <input type="submit" className="buttonInput"
                                onClick={ event =>
                                  requestCategory(JSON.stringify(this.state.requestName),
                                                  JSON.stringify(this.state.selectedCategoryPath)).then(json => alertRequest(json))}
                                 value=" abschicken " />
                       </li>
                  </ul>
               </div>
              }
               {this.state.selectedCategoryHasChildren===true &&
                <div className="CategorySelectorSearch">
                  <div>
                    <input type="text" placeholder="Kategoriedirektsuche" value={this.state.searchString}
                           onChange={ (event) => this.setState({searchString: event.target.value},
                                                               () => this.search(this.state.searchString).then(
                                                                 (json) => this.setState({searchResults: json})))
                                    } />
                  </div>
                  <div>
                    {this.state.searchString.length >= 3 && this.renderSearchResults()}
                    {this.state.searchString.length > 0 &&
                     this.state.searchString.length < 3 &&
                     <span style={{color: 'red'}}>Geben Sie wenigstens drei Buchstaben Ihres Suchbegriffs ein.</span>
                    }
                  </div>
                </div>
               }
      </div>
    )
  }
}

function getCategoryInfo(id) {
  var headers = util.defaultHeaders();
  headers.append("Accept", "application/json");
  var url = `/api/full-category-info?id=${id}`;
  var promise = fetch(url, {method: 'GET',
                            mode: 'cors',
                            headers: headers
  })
    .then(response => response.json()).catch(function(exception) {
      console.error(`Could not retreive category node information!`, exception);
    });
  return promise;
}

function serializeCategories(self, maxCount, categoryInfo, removeDuplicates=true) {
  var value = new Array(0);
  var categories = self.state.categories;
  for(var id in categories) {
    if(categoryInfo[categories[id]] !== undefined && categoryInfo[categories[id]].hasChildren !== true) {
      value.push(categories[id]);
    }
  }
  if(removeDuplicates === true) {
    value = value.map( (item) => parseInt(item, 10) );
    value = value.filter( (item, pos, self) => self.indexOf(item) === pos);
  }
  var length = value.length;
  for(var i=0; i<maxCount-length; i++) {
    value.push(null);
  }
  return value.toString();
}

function alertRequest (json) {
  var category = json.category;
  var user = json.user;
  alert(`Lieber ${user}, Ihr Kategorienwunsch ${category} wurde entgegengenommen. Vielen Dank!`);
}

function requestCategory(category, path) {
  var headers = util.defaultHeaders();
  headers.append("Accept", "application/json");
  headers.append('Content-Type', 'application/x-www-form-urlencoded');
  var url = `/api/request-category`;
  var promise = fetch(url, {method: 'POST',
                            mode: 'cors',
                            headers: headers,
                            body: `category=${category}&path=${path}`
  })
    .then(response => response.json()).catch(function(exception) {
      console.error(`Could not request category!`, exception);
    });
  return promise;
}



// WEBPACK FOOTER //
// ./src/category-selector-rewrite.js